import Vue from 'vue'
import Vuex from 'vuex'
import db from '../db'
import axios from 'axios'
import Defaults from '../config/Defaults'
import firebase from "firebase/app";
import "firebase/auth";



Vue.use(Vuex)

export default new Vuex.Store({
  modules: {

  },
  state() {
    return {
      user: null,
      the_app_data: null
    }
  },
  getters: {
    isAuthenticated(state) {
      return !!state.user
    }
  },
  actions: {
    test() {
      alert('heLlo vuex');
    },
    logOut() {
      this.state.user = null;
      this.state.the_app_data = null;
      firebase.auth().signOut();
    },
    login() {

      var provider = new firebase.auth.OAuthProvider('google.com');
      firebase.auth().signInWithPopup(provider)
        .then((result) => {
          // IdP data available in result.additionalUserInfo.profile.
          // ...
          //console.log(JSON.stringify(result))
          /** @type {firebase.auth.OAuthCredential} */

          createAuthUser(result)
          var credential = result.credential;

          // OAuth access and id tokens can also be retrieved:
          var accessToken = credential.accessToken;
          var idToken = credential.idToken;
        })
        .catch((error) => {
          console.log(error)
        });
    }
  },
  mutations: {
    setAuthUser(state, user) {

      if (user) {
        let str = JSON.stringify(user);

        let obj = JSON.parse(str);



        var headers = {
          email: user.email,
          env: 'google.com',
          authtoken: obj.stsTokenManager.accessToken
        };

        axios({
          method: "get",
          url:
            Defaults.applications().backEnd.url + "/api/validateAuthUser",
          headers: headers,
        })
          .then((response) => {
            if (response.data.code == 100) {
              //success
              state.user = user;
              state.the_app_data = response.data;
              //console.log("setted")

            } else if (response.data.code == 201) {
              //success
              //console.log("setted")

            }
          })
          .catch((error) => {
            if (error.response.status == 429) {
              //rate Limit

            }
            // error message
            state.user = null;
            state.the_app_data = null;
           // alert(error.message);
          });
      } else {
        state.user = null;
        state.the_app_data = null;
      }


    }
  }
});

function createAuthUser(result) {
  //console.log("createAuthUser")
  if (result) {
    //console.log("result")
    let str = JSON.stringify(result.user);

    //let obj=JSON.parse(str);

    const obj = JSON.parse(JSON.stringify(result.user))
    const email = result.user.email
      ? result.user.email
      : (result.additionalUserInfo && result.additionalUserInfo.profile
        ? result.additionalUserInfo.profile.email : null)

    console.log("email:" + email)

    var headers = {
      email: email,
      env: 'google',
      authtoken: obj.stsTokenManager.accessToken,
      accesstoken: result.credential.accessToken
    };



    axios({
      method: "get",
      url:
        Defaults.applications().backEnd.url + "/api/validateAuthUser",
      headers: headers,
    })
      .then((response) => {
        if (response.data.code == 100) {


        }
      })
      .catch((error) => {
        console.log(error)
      });
  } else {

  }


}


// WEBPACK FOOTER //
// ./src/store/index.js